module.exports = __webpack_public_path__ + "media/images/video-icon-2f76b4eea28f8dae226c61dac7f6aafcf5627f5594d89438c76a17e15f04b0ee.png";